module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "foo"
  }, [_c('H1', [_vm._v(_vm._s(_vm.locale.t('label_personal_title')))]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "new-button btn-my",
    on: {
      "click": function($event) {
        return _vm.addPersonalProgram()
      }
    }
  }, [_c('i', {
    staticClass: "ti-plus"
  }), _vm._v(" " + _vm._s(_vm.locale.t("label_add_new_personal_program")) + "\n\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "new-button btn-my",
    on: {
      "click": function($event) {
        return _vm.allPersonalTrainings()
      }
    }
  }, [_c('i', {
    staticClass: "ti-list"
  }), _vm._v(" " + _vm._s(_vm.locale.t("label_all_the_exercises")) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "scrollmenu"
  }, [_c('span', {
    staticClass: "chips-group",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "value": ""
    },
    on: {
      "click": function($event) {
        return _vm.toggleTemplateFilter()
      }
    }
  }, [_c('span', {
    staticClass: "single-chip"
  }, [_c('span', {
    class: _vm.isTemplateFilter ? 'chip-selected' : 'chip-unselected'
  }, [_vm._v(_vm._s(_vm.isTemplateFilter ? '✔ ' : '') + _vm._s(_vm.locale.t('label_pp_predefined_programs')))])])]), _vm._v("\n       \n         "), _vm._l((_vm.activePrograms), function(item) {
    return _c('span', [_c('span', {
      staticClass: "chips-group",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "value": ""
      },
      on: {
        "click": function($event) {
          return _vm.clickSelectState(item)
        }
      }
    }, [_c('span', {
      staticClass: "single-chip"
    }, [_c('span', {
      class: _vm.getChipClass(item)
    }, [_vm._v(_vm._s(_vm.isSelected(item) ? '✔ ' : '') + _vm._s(item.name))])])]), _vm._v(" \n          ")])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "input search-input-wide",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_search_trainings_definition'),
      "name": "users"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "keyup": _vm.keymonitor,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content table-responsive table-full-width"
  }, [_c('table', {
    staticClass: "table-main table-main--fixed"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_personal_user")) + " / "), _c('p', {
    staticClass: "pp-color-company"
  }, [_c('b', [_vm._v(_vm._s(_vm.locale.t("label_personal_company")))])])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_pp_name")))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_pp_from_date")))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_pp_from_to")))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_edit_exercise")))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_copy_program")))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_results")))]), _vm._v(" "), (_vm.role === 'ROLE_SUPER_ADMIN') ? _c('th', {
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_view")))]) : _vm._e(), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_edit")))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_delete")))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.programs), function(item) {
    return _c('tr', [(item.partnerCompanyName == null) ? _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_personal_user') + '/' + _vm.locale.t('label_personal_company')
      }
    }, [_vm._v(_vm._s(item.firstName) + " " + _vm._s(item.lastName))]) : _vm._e(), _vm._v(" "), (item.partnerCompanyName != null) ? _c('td', {
      staticClass: "pp-color-company",
      attrs: {
        "data-title": _vm.locale.t('label_personal_user') + '/' + _vm.locale.t('label_personal_company')
      }
    }, [_vm._v(_vm._s(item.partnerCompanyName))]) : _vm._e(), _vm._v(" "), _c('td', {
      class: ['personal-program-name', {
        'personal-program-name--user': !item.publicProgram && (item.partnerCompanyName == null || item.partnerCompanyName === ''),
        'personal-program-name--partner': item.partnerCompanyName != null && item.partnerCompanyName !== '',
        'personal-program-name--public': item.publicProgram
      }],
      attrs: {
        "data-title": _vm.locale.t('label_pp_name')
      }
    }, [_vm._v(_vm._s(_vm.getName(item)))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_pp_from_date')
      }
    }, [_vm._v(_vm._s(_vm.formatDate(item.startTime)))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_pp_from_to')
      }
    }, [_vm._v(_vm._s(_vm.formatDate(item.endTime)))]), _vm._v(" "), _c('td', {
      staticClass: "clickable",
      attrs: {
        "data-title": _vm.locale.t('label_edit_exercise')
      }
    }, [_c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.previewProgram(item.id, item.userId)
        }
      }
    }, [_c('i', {
      staticClass: "ti-pencil"
    }), _vm._v(" " + _vm._s(_vm.locale.t("label_edit_exercise")) + "\n                ")])]), _vm._v(" "), _c('td', {
      staticClass: "clickable",
      attrs: {
        "data-title": _vm.locale.t('label_copy_program')
      }
    }, [_c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.copyPersonalProgram(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "ti-share"
    }), _vm._v(" " + _vm._s(_vm.isTemplateFilter ? _vm.locale.t("label_assign_program_action") : _vm.locale.t("label_copy_program_action")) + "\n                ")])]), _vm._v(" "), _c('td', {
      staticClass: "clickable",
      attrs: {
        "data-title": _vm.locale.t('label_results')
      }
    }, [_c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.programResults(item)
        }
      }
    }, [_c('i', {
      staticClass: "ti-list-ol"
    }), _vm._v(" " + _vm._s(_vm.locale.t("label_results")) + "\n                ")])]), _vm._v(" "), (_vm.role === 'ROLE_SUPER_ADMIN') ? _c('td', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "data-title": _vm.locale.t('label_view')
      }
    }, [_c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.viewPersonalProgram(item)
        }
      }
    }, [_c('i', {
      staticClass: "ti-pencil"
    }), _vm._v(" " + _vm._s(_vm.locale.t("label_view")) + "\n                ")])]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "clickable",
      attrs: {
        "data-title": _vm.locale.t('label_edit')
      }
    }, [_c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.editPersonalProgram(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "ti-pencil"
    }), _vm._v(" " + _vm._s(_vm.locale.t("label_edit")) + "\n                ")])]), _vm._v(" "), _c('td', {
      staticClass: "clickable",
      attrs: {
        "data-title": _vm.locale.t('label_delete')
      }
    }, [_c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.deletePersonalProgram(item)
        }
      }
    }, [_c('i', {
      staticClass: "ti-trash"
    }), _vm._v(" " + _vm._s(_vm.locale.t("label_delete")) + "\n                ")])])])
  }), 0)]), _vm._v(" "), (_vm.pagination.totalCount > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('pagination', {
    attrs: {
      "active-page": _vm.pagination.page,
      "total": _vm.pagination.totalCount,
      "limit": _vm.pagination.limit
    }
  })], 1)]) : _vm._e()])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4bfd8278!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Personal/Personal.vue
// module id = 780
// module chunks = 0